const pollDetailFragment = `
    fragment PollDetailFragment on Poll {
        title
        richDescription
        url
        accessId
        timePublished
        statusPublished
        hasVoted
        canEdit
        canVote
        voteWithoutAccount
        choices {
            guid
            text
            votes
        }
    }
`
export default pollDetailFragment
